var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-p"},[_c('ul',[_vm._l((_vm.data),function(item,index){return [_c('li',{on:{"click":function($event){return _vm.goPageBack(item)}}},[_c('img',{attrs:{"src":item.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"ac-title"},[_vm._v(_vm._s(item.name))])])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3e4b87","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activty/event-review.vue
// module id = null
// module chunks = 